import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PointsIcon } from "src/assets/Icons";
import { SelectedGiftcard } from "src/store/slices/item/subitems/giftcards.types";
import { formatNumber } from "src/utility";
import GiftcardsRedeem from "../GiftcardsRedeem/GiftcardsRedeem";

type Props = {
  data: SelectedGiftcard | undefined;
  imageUrl: string | undefined;
  itemCode: string;
};

const GiftcardRedeemBar: FC<Props> = ({ data, imageUrl, itemCode }) => {
  const { t } = useTranslation();
  const points = data?.points ?? 0;

  return (
    <div className="flex items-center justify-between gap-4 md:gap-6">
      <div className="flex flex-col">
        <span className="text-xs text-font-subtle">{t("Giftcards.youWillSpend")}</span>
        <div className="flex items-center gap-2 text-lg font-semibold text-font-active md:text-xl">
          <div className="text-secondary-60">
            <PointsIcon />
          </div>
          {t("Giftcards.pointsCount", { count: points, value: formatNumber(points) })}
        </div>
      </div>
      <div className="w-40 shrink-0 md:w-64">
        <GiftcardsRedeem data={data} imageUrl={imageUrl} itemCode={itemCode} />
      </div>
    </div>
  );
};

export default GiftcardRedeemBar;
